/**
 * `allows_write_to_pm` — il permesso che l'utente ha dato (o non ha dato) a
 * `@QLASH_APP_bot` di scrivergli in privato, come arriva dentro `initData`.
 *
 * ═══ PERCHE' ESISTE ═══
 * ADR-0107 decisione 1: le DM di piattaforma escono da QBot con un **secondo mittente**,
 * il token di `@QLASH_APP_bot`, e il legame Telegram↔`sub` e' **fail-closed**. Chi non
 * ha dato quel permesso non e' raggiungibile, e oggi **nessuno di noi sa quanti siano**:
 * il campo c'e' in ogni `initData` della Mini App e non e' mai stato guardato.
 *
 * ═══ 🔴 TRE STATI, NON DUE ═══
 * Il campo e' **opzionale** (`allows_write_to_pm?: boolean`,
 * `@tma.js/types/dist/dts/init-data.d.ts:13`): «assente» vuol dire **che Telegram non ce
 * l'ha detto**, non che l'utente abbia rifiutato.
 * ⚠️ `!!user.allows_write_to_pm` — la forma ovvia — collassa i due, e l'errore ha un verso
 * preciso: produce una lista di «irraggiungibili» che contiene persone raggiungibilissime.
 * Un errore del genere **si vede solo dal lato dei messaggi che non arrivano**, cioe' non
 * si vede. E' la stessa famiglia dei cinque stati vuoti dei pannelli della Hub: *un vuoto
 * e' un'affermazione, e non si afferma cio' che non si e' chiesto.*
 *
 * ⛔ Qui **non si decide niente**: questo modulo osserva e scrive una riga. Il consenso
 * alle DM ha una regola sua (ADR-0084), e chi la implementera' partira' da un numero
 * invece che da un'impressione.
 */

export const DM_CONSENT_LOG_PREFIX = 'dm-consent:';

export type DmConsent = 'allowed' | 'denied' | 'unknown';

/**
 * L'utente di `initData`. L'indice aperto non e' pigrizia: dice che l'oggetto vero ha
 * molti altri campi (id, first_name, username, is_premium…) e che qui se ne legge **uno**.
 * Senza, un test che passa un utente realistico non compila, e la reazione naturale
 * sarebbe restringere il test invece del tipo — cioe' far somigliare la prova al codice
 * invece che al mondo.
 */
interface UtenteConPermesso {
  readonly allows_write_to_pm?: boolean;
  readonly [altroCampo: string]: unknown;
}

export function dmConsentOf(user: UtenteConPermesso | null | undefined): DmConsent {
  if (!user) return 'unknown';
  if (user.allows_write_to_pm === true) return 'allowed';
  if (user.allows_write_to_pm === false) return 'denied';
  return 'unknown';
}

/**
 * La riga di registro. Passa da `dbg()` (`lib/logto.ts`), quindi finisce nel giro
 * persistente `qlash.bridge_debug.v2` e in eruda su `dev-tma`: e' leggibile **dal
 * telefono di chi sta facendo il collaudo**, che e' l'unico posto da cui oggi qualcuno
 * puo' vedere un `initData` vero.
 */
export function describeDmConsent(user: UtenteConPermesso | null | undefined): string {
  return `${DM_CONSENT_LOG_PREFIX} ${dmConsentOf(user)}`;
}
